// @flow

import { jsonGetRequest } from '../../store/requests';

export function formatMoney(cents: number = 0): string {
    return new Intl.NumberFormat('en-CA', {
        style: 'currency',
        currency: 'CAD',
        minimumFractionDigits: 2,
    }).format((cents || 0) / 100);
}

export function formatCount(value: number = 0): string {
    return new Intl.NumberFormat('en-CA').format(value || 0);
}

export function formatTimestamp(timestamp: ?number): string {
    if (!timestamp) return 'Pending';

    return new Intl.DateTimeFormat('en-CA', {
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
    }).format(new Date(timestamp * 1000));
}

export function getBillStatusLabel(status: number): string {
    switch (status) {
        case 1:
            return 'Open';
        case 2:
            return 'Closed';
        case 3:
            return 'Canceled';
        case 4:
            return 'Completed';
        case 5:
            return 'Manual';
        case 6:
            return 'Completed (Manual)';
        default:
            return 'Unknown';
    }
}

export function getTransactionStatusLabel(status: number): string {
    switch (status) {
        case 1:
            return 'Processing';
        case 2:
            return 'Reprocessing';
        case 3:
            return 'Approved';
        case 4:
            return 'Failed';
        case 5:
            return 'Declined';
        case 6:
            return 'Canceled';
        default:
            return 'Unknown';
    }
}

export function getStatusTone(status: string): string {
    switch (status) {
        case 'critical':
            return 'danger';
        case 'warning':
            return 'warning';
        case 'healthy':
            return 'success';
        default:
            return 'secondary';
    }
}

export function getRiskScope(key: ?string): ?string {
    switch (key) {
        case 'guestDistressSignals':
        case 'guestDistressWatchlist':
        case 'guestWatchlist':
            return 'guest';
        case 'paymentIssuesByLocation':
        case 'paymentFailuresToTriage':
        case 'billsNeedingIntervention':
        case 'openSupportQueue':
        case 'followUpsDue':
        case 'paymentAlerts':
        case 'supportQueue':
        case 'transactionAlerts':
        case 'billAlerts':
            return 'operator';
        default:
            return null;
    }
}

export function getRiskScopeLabel(scope: ?string): string {
    switch (scope) {
        case 'guest':
            return 'Guest risk';
        case 'operator':
            return 'Operator risk';
        default:
            return '';
    }
}

export function getRiskScopeTone(scope: ?string): string {
    switch (scope) {
        case 'guest':
            return 'info';
        case 'operator':
            return 'secondary';
        default:
            return 'light';
    }
}

export function formatMetricValue(card: { value: number, valueType?: string }): string {
    if (card.valueType === 'money') return formatMoney(card.value || 0);
    return formatCount(card.value || 0);
}

export function fetchOverviewMetrics(): Promise<any> {
    return jsonGetRequest('operations/overview');
}

export function fetchRestaurantActivityMetrics(): Promise<any> {
    return jsonGetRequest('operations/restaurant-activity');
}

export function fetchSupportMetrics(): Promise<any> {
    return jsonGetRequest('operations/support-monitor');
}
